import React from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import UserDefinitions from "../../components/Definitions/UserDefinitions";
import {
  CumulativeUsersOverTime,
  RegidsteredUsersChart,
  UserStatsCircleCharts,
  DroppersPerStoreChart,
  DropsPerUserPerLocationChart,
} from "../../components";

const UsersScreenReporting = () => {
  return (
    <main>
      <UserDefinitions />
      <CumulativeUsersOverTime useFromToFilters />
      <UserStatsCircleCharts />
      <RegidsteredUsersChart />
      <DroppersPerStoreChart />
      <DropsPerUserPerLocationChart />
    </main>
  );
};

export default withProtectedRoute(UsersScreenReporting);
